import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  WEB_ORDER_ACCESS_PERMISSIONS,
  WEB_ORDER_CUSTOMER_ACCESS_PERMISSIONS,
  WEB_ORDER_PRODUCT_ACCESS_PERMISSIONS,
} from 'dashboard/constants/permissions';

const commonMeta = {
  permissions: ['administrator', ...WEB_ORDER_ACCESS_PERMISSIONS],
};
const createMeta = {
  permissions: ['administrator', 'web_order_create'],
};
const editMeta = {
  permissions: ['administrator', 'web_order_edit'],
};
const productsMeta = {
  permissions: ['administrator', ...WEB_ORDER_PRODUCT_ACCESS_PERMISSIONS],
};
const customersMeta = {
  permissions: ['administrator', ...WEB_ORDER_CUSTOMER_ACCESS_PERMISSIONS],
};
const integrationMeta = {
  permissions: ['administrator', 'integration_manage'],
};
// Agents queue/profile is order ops (managers have web_order_manage, not
// always integration_manage). Keep integration_manage for existing grants.
const agentsMeta = {
  permissions: [
    'administrator',
    ...WEB_ORDER_ACCESS_PERMISSIONS,
    'integration_manage',
  ],
};
const invoiceSettingsMeta = {
  permissions: ['administrator', 'web_order_invoice_settings'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/web-order/orders'),
    name: 'web_order_orders',
    component: () => import('./pages/OrdersPage.vue'),
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/orders/new'),
    name: 'web_order_order_new',
    component: () => import('./pages/CreateOrderPage.vue'),
    meta: createMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/orders/:orderId'),
    name: 'web_order_order_detail',
    component: () => import('./pages/OrderDetailsPage.vue'),
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/orders/:orderId/edit'),
    name: 'web_order_order_edit',
    component: () => import('./pages/EditOrderPage.vue'),
    meta: editMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/products'),
    name: 'web_order_products',
    component: () => import('./pages/ProductsPage.vue'),
    meta: productsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/customers'),
    name: 'web_order_customers',
    component: () => import('./pages/CustomersPage.vue'),
    meta: customersMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/customers/:customerId'),
    name: 'web_order_customer_profile',
    component: () => import('./pages/CustomerProfilePage.vue'),
    meta: customersMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/agents'),
    name: 'web_order_agents',
    component: () => import('./pages/AgentsPage.vue'),
    meta: agentsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/agents/:agentId'),
    name: 'web_order_agent_profile',
    component: () => import('./pages/AgentProfilePage.vue'),
    meta: agentsMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/integrations/store'),
    name: 'web_order_integrations_store',
    component: () => import('./pages/IntegrationsPage.vue'),
    props: { type: 'store' },
    meta: integrationMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/integrations/store/:storeId'),
    name: 'web_order_store_profile',
    component: () => import('./pages/StoreProfilePage.vue'),
    meta: integrationMeta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/web-order/integrations/delivery-partner'
    ),
    name: 'web_order_integrations_delivery_partner',
    component: () => import('./pages/IntegrationsPage.vue'),
    props: { type: 'delivery' },
    meta: integrationMeta,
  },
  {
    path: frontendURL('accounts/:accountId/web-order/integrations/invoice'),
    name: 'web_order_integrations_invoice',
    component: () => import('./pages/InvoiceSettingsPage.vue'),
    meta: invoiceSettingsMeta,
  },
];
